import { DebugElement, Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  AccessPermissionService,
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { CustomFacade, getRolesAndPermission } from '@piqet-angular/data';
import { cloneDeep } from 'lodash';
import { NumericCellEditor } from 'libs/ui/src/lib/numeri-cell-editor/numeric-cell-editor.component';
import { Subject, take } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class CustomReuseDataGridService {
  customReusePayload: any;
  event: any;
  Access: any;
  editData = new Subject<[any, any, any, any]>();
  customReuseObservable$ = this.editData.asObservable();
  currentRoute: string = '';
  constructor(
    private CustomFacade: CustomFacade,
    private swalService: SwalService,
    private toaster: ToastrService,
    private accessService: AccessPermissionService
  ) {}

  editReuse = new Subject<[any, any, any, any]>();
  editReuseObservable$ = this.editReuse.asObservable();

  deleteReuse = new Subject<[any, any, any]>();
  deleteReuseObservable$ = this.deleteReuse.asObservable();

  copyReuse = new Subject<[any, any, any]>();
  copyReuseObservable$ = this.copyReuse.asObservable();

  inlineEditing = new Subject<[any, any]>();
  inlineEditingObservable$ = this.inlineEditing.asObservable();

  accessAllPermission(type: string) {
    const access =
      this.isAccess(type, 'edit') || this.isAccess(type, 'delete') || this.isAccess(type, 'create');
    return access;
  }

  getCustomReuseDataColumn(pathName?: any): ColDef[] {
    this.currentRoute = pathName;
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'ProcessName',
      headerName: 'My custom reuse',
      field: 'processName',
      width: 468,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        const checkAccess = this.isAccess(pathName, 'edit') || this.isAccess(pathName, 'view');
        if (checkAccess) {
          cellElement.title = dblclickTooltipDef;
          cellElement.style.textDecoration = 'underline';
        }
        cellElement.addEventListener('dblclick', () => {
          checkAccess &&
            this.editReuse.next([params.data, params.data.id, 'Review custom reuse', pathName]);
        });
        return cellElement;
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: false,
    });

    {
      pathName == 'adminCustomReuse' &&
        colDef.push({
          ...defaultColumn,
          colId: 'OrganizationName',
          headerName: 'Organization name',
          field: 'organizationName',
          minWidth: grid_widths_map.sm_column_sm,

          cellClass: 'my-permission-cursor-pointer',
          wrapText: true,
          autoHeight: true,
          lockVisible: true,
          resizable: false,
          editable: false,
          filter: 'agTextColumnFilter',
        });
    }

    colDef.push({
      ...defaultColumn,
      colId: 'Cost per package (USD)',
      headerName: 'Cost per package (USD)',
      field: 'packageCostSum',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      width: 468,
      lockVisible: true,
      resizable: false,
      filter: 'agNumberColumnFilter',
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ownerName',
      headerName: 'Owner',
      field: 'ownerName',
      width: 468,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: false,
    });

    this.accessAllPermission(pathName) &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        cellRendererParams: {
          showEdit: this.isAccess(pathName, 'edit'),
          showCopy: this.isAccess(pathName, 'create'),
          showDelete: this.isAccess(pathName, 'delete'),
          value: 'customReuse',
          deleteData: (data: any, pathName: any) => {
            if (pathName == 'adminCustomReuse') {
              this.deleteCustomReuseConfirmation(
                data,
                '/AdminCustomReuse/DeleteCustomReuse',
                pathName
              );
            } else {
              this.deleteCustomReuseConfirmation(data, '/CustomReuse/DeleteCustomReuse', pathName);
            }
          },
          copyData: (data: any, pathName: any) => {
            if (pathName == 'adminCustomReuse') {
              this.copyReuse.next([data, '/AdminCustomReuse/SaveCopyCustomReuse', pathName]);
            } else {
              this.copyReuse.next([data, '/CustomReuse/SaveCopyCustomReuse', pathName]);
            }
          },
          editData: (data: any, pathName: any) => {
            this.editReuse.next([data, data.id, 'Review custom reuse', pathName]);
          },
          copyDataEditRendarar: (data: any) => {
            return false;
          },
        },
        maxWidth: grid_widths_map.sm_column_xs,

        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        lockVisible: true,
        lockPosition: right,
        resizable: false,
      });

    return colDef;
  }

  isAccess = (pathName: any, type: 'view' | 'edit' | 'create' | 'delete') => {
    return pathName.includes('admin')
      ? this.accessService.hasModulePermission(
          rolesModuleName.AdministratorReuse,
          mainModuleName.projectManagementModule,
          type
        )
      : this.accessService.hasModulePermission(
          rolesModuleName.customReuse,
          mainModuleName.customModule,
          type
        );
  };

  deleteCustomReuseConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteReuse.next([data, customType, pathName]);
      }
    });
  }

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getCustomReuseDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.customReusePayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'processName',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Desc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  innedGridActionAccess(fromEdit: boolean): boolean {
    return (
      (!fromEdit && this.isAccess(this.currentRoute, 'create')) ||
      (fromEdit && !this.isAccess(this.currentRoute, 'view')) ||
      (fromEdit && this.isAccess(this.currentRoute, 'edit'))
    );
  }

  getNewProcessColumns(fromEdit: boolean = false): ColDef[] {
    let newValue: any;
    let energyProcessId: any;
    let enableEditing: any;
    let resetData: any;
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'process',
      headerName: 'Process',
      field: 'energyProcessName',
      cellClass: 'my-permission-cursor-pointer',
      cellEditor: 'GridCellRendererComponent',
      cellEditorParams: {
        from: 'reuse',
        editData: (data: any) => {
          newValue = data.processName;
          energyProcessId = data.energyProcessId;
        },
      },
      cellRenderer: (params: any) => {
        return `<div class="truncated-text" title="${params.value}">${
          params.value ? params.value : ''
        }</div>`;
      },
      valueSetter: (params: any) => {
        const newVal = !!newValue ? newValue : 'Select process';
        const valueChanged =
          !!newValue && !resetData ? params.data[params.colDef.field] !== newVal : false;
        params.data = { ...params.data };
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
          params.data['energyProcessId'] = energyProcessId;
          params.data['enableEditing'] = enableEditing;
          const colId = params.colDef.field;
          const nodeId = params.data.energyId;
          this.CustomFacade.checkUpdateActionFire$.pipe(take(1)).subscribe((flag: boolean) => {
            flag &&
              this.CustomFacade.updateReuseIngredientAction(
                params.data,
                'edit',
                null,
                nodeId,
                colId
              );
          });

          newValue = '';
          energyProcessId = '';
        }
        return valueChanged;
      },
      valueGetter: params => {
        return params.data.energyProcessName;
      },

      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: true,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'amount',
      headerName: 'Amount',
      field: 'amount',
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: true,
      sortable: false,
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'amount') {
          return {
            component: NumericCellEditor,
            params: {
              type: 'reuseComponent',
            },
          };
        }
        return undefined;
      },
      valueSetter: (params: any) => {
        const newValInt = params.newValue;
        const valueChanged = !resetData && params.data[params.colDef.field] !== newValInt;
        params.data = { ...params.data };
        if (valueChanged) {
          params.data.amount =
            typeof params.oldValue == 'number' ? parseFloat(newValInt) : newValInt;
          const colId = params.colDef.field;
          params.data['enableEditing'] = enableEditing;
          const nodeId = params.data.id;
          this.CustomFacade.checkUpdateActionFire$.pipe(take(1)).subscribe((flag: boolean) => {
            flag &&
              this.CustomFacade.updateReuseIngredientAction(
                params.data,
                'edit',
                null,
                nodeId,
                colId
              );
          });
          return valueChanged;
        } else {
          return false;
        }
      },
    });

    this.innedGridActionAccess(fromEdit) &&
      colDef.push({
        ...defaultColumn,
        colId: 'actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'inlineActionButtonComponent',
        cellRendererParams: {
          showInlineEdit: true,
          showInlineCopy: true,
          showInlineDelete: true,
          from: 'customReuse',
          copyDataEditRendarar: (data: any) => {
            this.CustomFacade.copyReuseIngredientAction(data, 'copy');
          },
          copyData: (data: any) => {
            return false;
          },
          inlineEditData: (data: any) => {
            enableEditing = data.data.enableEditing;
            resetData = data.data.resetData;
          },
          deleteInlineGrid: (data: any) => {
            this.alertConfirmation(data);
          },
        },
        lockVisible: true,
        lockPosition: right,
        resizable: false,
      });
    return colDef;
  }

  alertConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.CustomFacade.deleteReuseIngredientAction(data, 'delete');
      }
    });
  }

  isEmpty(val: any) {
    if (val !== undefined || val !== null || val !== '') {
      val = val.trim();
    }
    return val === undefined || val === null || val === '';
  }
}
